/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuoteResponseDto } from '../../models/sales-quote-response-dto';

export interface QuotesControllerRemove$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the quote to delete.
 */
  id: string;
}

export function quotesControllerRemove(http: HttpClient, rootUrl: string, params: QuotesControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotesControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuoteResponseDto>;
    })
  );
}

quotesControllerRemove.PATH = '/o2-sales/quotes/{tenant}/{id}';
